module.exports = __webpack_public_path__ + "static/media/ka com.b6dfe621.png";